module.exports = __webpack_public_path__ + "img/37800.7b3be4c5.jpg";